import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'organizationType' })
export class OrganizationTypePipe implements PipeTransform {
  private translateService = inject(TranslateService);


  transform(value?: string): string {
    if (!value) {
      return '-';
    }

    return this.translateService.instant(`organizations.typeItems.${value}`);
  }
}
